import React from "react";
import { MuiPickersUtilsProvider, DatePicker, DatePickerProps } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import fiLocale from "date-fns/locale/fi";
import format from "date-fns/format";

class FiLocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date: Date) {
    return format(date, "LLLL", { locale: fiLocale });
  }

  getDatePickerHeaderText(date: Date) {
    return format(date, "d. MMMM", { locale: fiLocale });
  }
}

const LocalizedDatePicker = ({ ...props }: DatePickerProps): JSX.Element => {
  if (props.variant === "dialog") {
    props.todayLabel = "Tänään";
    props.cancelLabel = "Peruuta";
    props.showTodayButton = true;
  }
  return (
    <MuiPickersUtilsProvider utils={FiLocalizedUtils} locale={fiLocale}>
      <DatePicker format="dd.MM.yyyy" label="Päivämäärä" {...props} />
    </MuiPickersUtilsProvider>
  );
};

export default LocalizedDatePicker;
